const mainHeader = document.querySelector('.l-header')
const main = document.querySelector('main')
let lastScrollTop = 0
let resizeTimeout

const setMenuHeight = () => {
    if (main && mainHeader) {
        main.style.paddingTop = window.innerWidth > 991 ? `${mainHeader.offsetHeight}px` : '80px'
    }
}

const handleScroll = () => {
    const st = window.scrollY || document.documentElement.scrollTop
    const isScrollingUp = st < lastScrollTop

    if (mainHeader) {
        mainHeader.classList.toggle('scroll-up', st > 90)

        if (st > 360) {
            mainHeader.classList.toggle('scroll-up', isScrollingUp)
            mainHeader.classList.toggle('scroll-down', !isScrollingUp)
        }
    }

    lastScrollTop = Math.max(st, 0)
}

const initMenuControl = () => {
    setMenuHeight()
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(setMenuHeight, 500)
    })
}

export { initMenuControl }
